import Vue from 'vue';
import Router from 'vue-router';
import dp from './dp.js';
// import justice from './justice.js';
Vue.use(Router);
let routes = new Set([...dp]);
// let routes = new Set([...dp]);
export default new Router({
    // mode: 'mode',
    routes
});



// WEBPACK FOOTER //
// ./src/router/index.js